import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Pagination from './Pagination';

const AdminDisplay = ({ searchQuery = '' }) => {
  const [admins, setAdmins] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';

  const fetchAdmins = async (page = 1) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: 50,
      };

      // Add search query if provided
      if (searchQuery) {
        params.search = searchQuery;
      }

      const response = await axios.get(`${API_BASE_URL}/admin/admins`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.data.data && response.data.pagination) {
        setAdmins(response.data.data);
        setPagination(response.data.pagination);
      } else {
        setAdmins(Array.isArray(response.data) ? response.data : []);
        setPagination(null);
      }
    } catch (err) {
      console.error('Failed to fetch admins:', err);
      setError('Failed to fetch admins');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchAdmins(page);
  };

  // Reset to page 1 when search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchAdmins(1);
  }, [searchQuery]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <table style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
        <thead style={{
          backgroundColor: 'rgb(250, 248, 255)',
          borderTop: '1px solid rgb(233, 230, 241)',
          borderBottom: '1px solid rgb(233, 230, 241)',
        }}>
          <tr className='link-row border-bottom'>
            <th className="p-3 text-center">Full Name</th>
            <th className="p-3 text-center">Email</th>
            <th className="p-3 text-center">Phone Number</th>
            <th className="p-3 text-center">User Type</th>
            <th className="p-3 text-center">Verified</th>
            <th className="p-3 text-center">Onboarded</th>
            <th className="p-3 text-center">Created</th>
          </tr>
        </thead>
        <tbody>
          {admins.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center p-3">No admin users found</td>
            </tr>
          ) : (
            admins.map(admin => (
              <tr key={admin.id} className="link-row border-bottom">
                <td className="p-2 text-center">{admin.fullName || 'N/A'}</td>
                <td className="p-2 text-center">{admin.email}</td>
                <td className="p-2 text-center">{admin.phoneNumber || 'N/A'}</td>
                <td className="p-2 text-center">
                  <span className="badge bg-danger">
                    {admin.userType || 'admin'}
                  </span>
                </td>
                <td className="p-2 text-center">
                  {admin.isVerified ? (
                    <span className="badge bg-success">Verified</span>
                  ) : (
                    <span className="badge bg-warning">Not Verified</span>
                  )}
                </td>
                <td className="p-2 text-center">
                  {admin.isOnboarded ? (
                    <span className="badge bg-success">Onboarded</span>
                  ) : (
                    <span className="badge bg-warning">Not Onboarded</span>
                  )}
                </td>
                <td className="p-2 text-center">
                  {new Date(admin.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default AdminDisplay;
